import { Theme, ThemeProvider } from "@mui/material";
import { ConfigProvider, theme } from "antd";
import React from "react";
import DarkTheme from "../src/components/UI/Themes/DarkTheme";
import LightTheme from "../src/components/UI/Themes/LightTheme";
import GlobalStoreContext from "../src/context/GlobalStoreContext";

interface Props {
    children: any;
    themeOverride?: Theme;
}

const GlobalTheme: React.FC<Props> = ({ children, themeOverride }) => {
    const globalStoreContext = React.useContext(GlobalStoreContext);

    const themeLogic = () => {
        if (themeOverride) {
            return themeOverride;
        }
        if (globalStoreContext.userInfo?.user_preferences?.theme === "dark") {
            return DarkTheme;
        }
        return LightTheme;
    };

    const antThemeLogic = () => {
        if (themeOverride && themeOverride === DarkTheme) {
            return theme.darkAlgorithm;
        }
        if (globalStoreContext.userInfo?.user_preferences?.theme === "dark") {
            return theme.darkAlgorithm;
        }
        return theme.defaultAlgorithm;
    };

    return (
        // MUI Theme provider
        <ThemeProvider theme={themeLogic()}>
            {/* Ant Design Theme Provider */}
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: "#FF9E00",
                        colorLink: "#FF9E00",
                    },
                    components: {
                        Menu: {
                            itemBorderRadius: 8,
                            subMenuItemBorderRadius: 4,
                            darkItemBg: "#363636",
                        },
                        Timeline: {
                            tailColor: "#222222",
                        },
                    },
                    algorithm: antThemeLogic(),
                }}
            >
                {children}
            </ConfigProvider>
        </ThemeProvider>
    );
};

export default GlobalTheme;
